import GATSBY_COMPILED_MDX from "/Users/nathanphennel/Projects/code/enphnt.github.io/blog/vst-plugins/index.mdx";
import * as React from 'react';
import {graphql} from 'gatsby';
import Layout from '../../components/layout';
import Seo from '../../components/seo';
import TagLinks from '../../components/tag-links';
import TableOfContents from '../../components/table-of-contents';
import RandomPost from '../../components/random-post';
import Breadcrumbs from '../../components/breadcrumbs';
import BackToTop from '../../components/back-to-top';
import HeroImage from '../../components/hero-image';
const BlogPost = ({data, children}) => {
  const {mdx: {frontmatter: {title, tags, date, hero_image, hero_image_alt, hero_image_credit_link, hero_image_credit_text}, tableOfContents}} = data;
  return React.createElement(Layout, null, React.createElement("div", {
    style: {
      paddingTop: 20
    }
  }, React.createElement(Breadcrumbs, {
    title: title,
    path: "blog"
  }), hero_image && React.createElement(HeroImage, {
    image: hero_image,
    alt: hero_image_alt,
    credit: hero_image_credit_text,
    link: hero_image_credit_link
  }), React.createElement("h1", null, title), React.createElement(TagLinks, {
    tags: tags
  }), React.createElement("h5", null, date), React.createElement("br"), React.createElement(TableOfContents, {
    tocs: tableOfContents
  }), React.createElement(BackToTop), React.createElement("div", null, children), React.createElement("br"), React.createElement(RandomPost)));
};
export const query = graphql`
  query ($id: String) {
    mdx(id: {eq: $id}) {
      tableOfContents
      excerpt(pruneLength: 200)
      frontmatter {
        title
        tags
        slug
        date(formatString: "MMMM DD, YYYY")
        hero_image_alt
        hero_image_credit_link
        hero_image_credit_text
        hero_image {
          childImageSharp {
            gatsbyImageData
          }
        }
      }
    }
  }
`;
export const Head = ({location, data}) => React.createElement(Seo, {
  location: location,
  title: data.mdx.frontmatter.title,
  hero_image: data.mdx.frontmatter.hero_image,
  excerpt: data.mdx.excerpt
});
BlogPost
export default function GatsbyMDXWrapper(props) {
  return React.createElement(BlogPost, props, React.createElement(GATSBY_COMPILED_MDX, props));
}
;
